import SbpsSubmitForm from '../../components/molecules/sbps/SbpsSubmitForm.vue'
export default {
  components: { SbpsSubmitForm }
}
